
const StringUtils = {
    removeArticlesPrepositions(value){
        const regex = /\b(?:o|do|no|ao|pelo|os|dos|nos|aos|pelos|a|da|na|à|pela|as|das|nas|às|pelas|um|dum|num|uns|duns|nuns|uma|duma|numa|umas|dumas|numas|para|com)\b/gi;
        return value.replace(regex, "").replace(/\s+/g, " ").trim();
    }
}

export default StringUtils